import React from 'react';
import {Stack} from '@mui/material';
import {
  designSystemToken,
  Headline,
  Body,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import {FeatureInfo} from './getFeatureInfo';

function FeatureButton({
  featureInfo,
  onClick,
  isSelected,
  onMouseEnter,
  onMouseLeave,
}: {
  featureInfo: FeatureInfo;
  onClick: () => void;
  isSelected: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}) {
  return (
    <Stack
      role="button"
      tabIndex={0}
      aria-pressed={isSelected}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick();
        }
      }}
      border={`1px solid ${
        isSelected
          ? designSystemToken('semantic.bg.neutral')
          : designSystemToken('semantic.bg.neutral-inverse')
      }`}
      padding="24px"
      borderRadius="16px"
      onClick={onClick}
      sx={{
        'cursor': 'pointer',
        '&:hover': {
          backgroundColor: designSystemToken('semantic.bg.tertiary'),
        },
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Headline size="xs">{translate(featureInfo.name)}</Headline>
      <Body size="md">{translate(featureInfo.description)}</Body>
    </Stack>
  );
}

export default FeatureButton;
